import { isInApp } from './appLocationPermission';

// Message types shared with the RACEMAP App (mobile-apps/tracking-app/src/lib/webviewShare.ts).
type AppMessage =
  | { type: 'racemap-share'; url: string }
  | { type: 'racemap-race-video'; action: 'share' | 'download'; url: string; fileName: string };
type AppFeature = 'share' | 'race-video';

declare global {
  interface Window {
    // Set by app builds that handle the messages below; older builds would leave dead buttons.
    RacemapAppFeatures?: Array<string>;
  }
}

export function appSupports(feature: AppFeature): boolean {
  return isInApp() && (window.RacemapAppFeatures?.includes(feature) ?? false);
}

export function postToApp(message: AppMessage): void {
  window.ReactNativeWebView?.postMessage(JSON.stringify(message));
}
